import script from "./TheCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./TheCompany.vue?vue&type=script&setup=true&lang=js"

import "./TheCompany.vue?vue&type=style&index=0&id=12ef3c72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ef3c72"]])

export default __exports__